// extracted by mini-css-extract-plugin
export default {"root":"QRCodeViewItem_root__6jhi4"};